module.exports = {
      id: "upload-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#upload-usage",
      toString: function () {
        return this.url;
      }
    }